<template>
	<div class="menu-container">
    <!-- 功能网格 -->
    <div class="menu-grid">
      <div class="menu-item" 
          v-for="item in menuItems" 
          :key="item.id"
          @click="handleMenuClick(item)"
      >
        <div class="menu-icon">
          <van-image                     
              :src="item.icon"
              fit="contain"
          />
        </div>
        <div class="menu-text">{{ item.text }}</div>
      </div>
    </div>
	</div>
</template>

<script>	
  import { Dialog } from 'vant';
  import global from '../components/global.vue';
  export default {
    name: 'menus',
    data(){		
      return{			
        network: require("@/assets/icon/Network.png"),
        webchat: require("@/assets/icon/Web Chat.png"),				
        srso: require("@/assets/icon/feedback.png"),
        tips: require("@/assets/icon/tips.png"),
        reserve: require("@/assets/icon/reservation.png"),
        feedback: require("@/assets/icon/Unknow.png"),
        svcproduct: require("@/assets/icon/inwpolicy.png"),
        register: require("@/assets/icon/register.png"),
        inwpolicy: require("@/assets/icon/svcproduct.png"),
        onlineurl: 'https://www.lenovoimage.com/static/chatexpress/index.html?appid=svchome&portal=104',
        apps:require("@/assets/icon/apps.png"),
        appid:'',
        menuItems: [
          { id: 1, icon: require("@/assets/icon/Network.png"), text: '服务网络', action: 'toSvcnet' },
          { id: 2, icon: require("@/assets/icon/Web Chat.png"), text: '智能客服', action: 'tononlesvc' },
          { id: 3, icon: require("@/assets/icon/svcproduct.png"), text: '保修政策', action: 'toINWpolicy' },
          { id: 4, icon: require("@/assets/icon/register.png"), text: '保修查询', action: 'gotoShipinfo' },
          { id: 5, icon: require("@/assets/icon/inwpolicy.png"), text: '延保产品', action: 'toSvcproduct' },
          { id: 6, icon: require("@/assets/icon/register.png"), text: '产品注册', action: 'toRegister' },
          { id: 7, icon: require("@/assets/icon/reservation.png"), text: '服务预约', action: 'toRESERVE' },
          { id: 8, icon: require("@/assets/icon/feedback.png"), text: '工单查询', action: 'toSRSO' }
        ]
      }
    },		
    created() {
      if (this.$route.query.appid != null) {
        this.appid = this.$route.query.appid
      } else {
        this.appid = 'apps'
      }				
    },
    methods:{	
      handleMenuClick(item) {
        global.applog(item.text);
        this[item.action]();
      },
      
      tononlesvc(){
        var str = this.onlineurl +  this.appid	
        console.log(str)
        window.location.href= 'https://chatbot.lenovoimage.com/#/chathere?appid=svchome'
      },
      toSvcproduct(){
        this.$router.push({ path:'/oow'  })
      },
      toFeedback(){
        this.$router.push({ path:'/feedback'  })
      },
      toRESERVE(){
        this.$router.push({ path:'/reserve'  })					
      },
      toSvcnet(){
        this.$router.push({ path:'/asp'  })
      }, 
      toTIPS(){	
        this.$router.push({ path:'/tips'  })
      },			 
      toDriver(){
        this.$router.push({ path:'/drivers'  })				
      },
      toAPP(){
        // APP下载功能
      },
      toWebchat(){
        var ho = new Date().getHours();
        if ( ho >= 9 && ho < 20 ) {
          window.location.href = 'https://www.lenovoimage.com/static/chatexpress/index.html?appid=' + this.appid;
        } else {
          Dialog.alert({
            title: '温馨提示',
            message: '不好意思，在线服务时间从早9点到晚8点，您也可以留下意见建议，我们稍后联系。'
          })
        } 
      },			 
      toINWpolicy(){
        this.$router.push({ path:'/policy'  })		
      },
      toSRSO(){
        this.$router.push({ path:'/srso'  })		
      },
      toRegister(){
         this.$router.push({ path:'/register'  })		
      },
      gotoShipinfo(){
        this.$router.push({ path:'/shipinfo'  })	
      },
      gotoAPP(){
        this.$router.push({ path:'/apps'  })
      }		 
    }
  }
</script>

<style scoped>
.menu-container {
  background: linear-gradient(135deg, #f7f8fa 0%, #ffffff 100%);
  padding: 12px 8px;
  box-sizing: border-box;
  width: 100%;
  overflow: hidden;
}

.menu-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
}

.menu-item {
  background: #ffffff;
  border-radius: 12px;
  padding: 8px 4px;
  text-align: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 80px;
}

.menu-item:active {
  background: #f7f8fa;
  transform: scale(0.95);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.menu-icon {
  margin-bottom: 8px;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9ff, #e8f4ff);
  border-radius: 10px;
  padding: 8px;
  box-sizing: border-box;
}

.menu-text {
  font-size: 12px;
  font-weight: 500;
  color: #323233;
  line-height: 1.4;
  word-break: break-all;
}

/* 小屏幕优化 - 仅调整间距和内边距 */
@media (max-width: 390px) {
  .menu-container {
    padding: 8px 6px;
  }
  
  .menu-grid {
    gap: 6px;
  }
  
  .menu-item {
    padding: 6px 3px;
    min-height: 75px;
    border-radius: 10px;
  }
  
  .menu-icon {
    margin-bottom: 6px;
    padding: 6px;
  }
}

@media (max-width: 360px) {
  .menu-container {
    padding: 6px 4px;
  }
  
  .menu-grid {
    gap: 4px;
  }
  
  .menu-item {
    padding: 5px 2px;
    min-height: 70px;
    border-radius: 8px;
  }
  
  .menu-icon {
    margin-bottom: 4px;
    padding: 4px;
  }
}

/* 悬停效果（桌面端） */
@media (hover: hover) {
  .menu-item:hover {
    background: #f7f8fa;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
  }
}
</style>